import { type ErrorCodeMap } from './types';

export const emisErrorCodes: ErrorCodeMap = {
  INTEGRATION_EMIS_NOT_CONNECTED: 'desktop.errors.integration.notConnected',
  INTEGRATION_EMIS_SESSION_EXPIRED: 'desktop.errors.integration.sessionExpired',
  INTEGRATION_EMIS_COM_ERROR: 'desktop.errors.integration.emis',
  INTEGRATION_EMIS_API_ERROR: 'desktop.errors.integration.emis',
  INTEGRATION_EMIS_CONFIG_ERROR: 'desktop.errors.integration.emis',
  INTEGRATION_EMIS_PLATFORM_ERROR: 'desktop.errors.integration.emis',
};
